var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43.79,
    height: 32,
    viewBox: "0 0 43.79 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M0 6.206A5.684 5.684 0 0 1 5.684.522h18.948a5.684 5.684 0 0 1 5.684 5.684v11.368a5.684 5.684 0 0 1-5.684 5.684h-6.794l-7.024 7.024a1.906 1.906 0 0 1-2.066.412 1.896 1.896 0 0 1-1.168-1.75v-5.686H5.684A5.684 5.684 0 0 1 0 17.574V6.206Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.726 19.242v2.61h5.222v-2.61h-5.222Zm-2.61 8.628c1.254.926 2.884 2.154 4.178 3.12.522-.692 1.044-1.396 1.566-2.088-1.292-.966-2.924-2.194-4.178-3.134a273.82 273.82 0 0 1-1.566 2.102Zm5.744-15.676c-.522-.692-1.044-1.396-1.566-2.088-1.294.966-2.924 2.192-4.178 3.132.522.692 1.044 1.396 1.566 2.088 1.254-.94 2.886-2.154 4.178-3.132Zm-21.408 4.438a2.62 2.62 0 0 0-2.61 2.61v2.61a2.62 2.62 0 0 0 2.61 2.612h1.306v5.22h2.61v-5.22h1.306L31.2 28.38V12.716l-6.526 3.916h-5.222Zm6.566 2.232 2.572-1.54v6.448l-2.572-1.54-.626-.38h-5.94v-2.61h5.94l.626-.378Zm8.446 1.684a5.856 5.856 0 0 0-1.958-4.374v8.734a5.803 5.803 0 0 0 1.958-4.36Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26.018 18.864 2.572-1.54v6.448l-2.572-1.54-.626-.38h-5.94v-2.61h5.94l.626-.378Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/Campaign.74b72c69ab8cd0a533f56379122436f5.svg";
export { ForwardRef as ReactComponent };